<template>
    <el-row class="main-box">
        <el-col >
				<el-col class="listdivcls" :xs="{span:22,offset:1}" :sm="{span:22,offset:1}"  :md="{span:22,offset:1}" :lg="{span:20,offset:2}">
					<div class="texttitle">{{tiemcs}}月优秀学员</div>
					<div v-if="datalist!=null&&datalist.length>0" class="gridcls">
						<div  class="itembgcls" v-for="(itemdata, indexdata) in datalist" :key="indexdata">
						
						<div class="itemb2">
						<div class="bgcls3"></div>
						<div style="position: relative;width: 86%;margin: 0 auto;height: 100%;">
						
						
						
						<div  class="bgimgcls">
							  <img  class="itemimag2"  :src="
							  itemdata.avatar?itemdata.avatar:
							  itemdata.userSex==0?
							  'https://language-training.oss-cn-hangzhou.aliyuncs.com/webAvatar/man_20231104183013.png':
							  'http://language-training.oss-cn-hangzhou.aliyuncs.com/webAvatar/female_20231104182916.png'
							  "/>
						</div>
						
						<!-- <img class="bgimgcls" src="../static/yx_bg1.png"/> -->
						  <!-- <img  class="itemimag2"  src="https://img.zhisheji.com/bbs/forum/201401/05/153945tbr7pg5torfzptso.jpg"/> -->
						 <div class="textdivlcs">
								<div class="text" style="margin-top: 10px;
									max-height: 60px; 
									overflow: hidden;">
									 {{itemdata.applyReason}}
									</div>
								<div class="text flex-row f-justify-between f-align-center" style="margin-top: 10px;">
									<span class="textcls1" style="color: #333333;">{{itemdata.studentName}}</span>
									<span class="textcls2" >{{itemdata.grade}}</span>
								</div>
								<div class="text flex-row f-align-center" style="margin-top: 14px;">
									<span style="color: #ACBEB0;">学校：</span>
									<span style="color: #333333;" >{{itemdata.school}}</span>
								</div>
								<div class="text flex-row f-align-center" style="margin-top: 5px;">
									<span style="color: #ACBEB0;">课程：</span>
									<span style="color: #333333;" >{{itemdata.courseName}}</span>
								</div>
							</div> 
							
							</div>
						
						</div>
						</div>
					</div>
					
					<el-col v-else class="content-box" >
					    <div class="flex-column flex1 f-align-center">
					        <img class="no-data" src="../static/saleClass-nodata.png" alt="">
					        <span>暂无数据</span>
					    </div>
					</el-col>
					
				</el-col>
			
			
        </el-col>
		<img v-if="userInfos.role == 1" class="fixed-img" @click="toApplictionBest" src="../static/find-student-badge.png" alt="">
    </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    data() {
        return {
			datalist:[
				
			],
			tiemcs:"",
        }
    },
    computed: {
        ...mapState([
			 'userInfos',
			'userToken',
        ]),
		  ...mapGetters(["getUserToken"]),
    },
	created() {
		const date = new Date();
		var mont= (date.getMonth() + 1);
		if(mont==1)
		{
			this.tiemcs=12;
		}else{
			this.tiemcs=mont-1;
		}
	    this.getdata();
	},
    methods: {
	async	getdata(){
			var res = await this.$api.get("/web/teacher/home/outstandStudentList", {
			    headers: { //头部参数
			        frontUserToken: this.getUserToken
			    }
			})
			
			if (res.code == 200) {
			    this.datalist = res.data;
			} else {
			    Message({
			        type: "error",
			        message: res.msg
			    })
			}
		},
		
		print(){
			this.$router.push({
			    path: "/day_print",
			}).catch(e => e)
		},
		toApplictionBest(){
			this.$router.push({
				path: "/application_beststudent"
			})
		}
    },
	
}
</script>

<style lang="scss" scoped>
.main-box {
    width: 100%;
    position: relative;
	flex: 1;
	background-color: #E5F3F1;

    .main-box-bg {
        width: 100%;
        // height: 230px;
        position: relative;
        top: 0;
        left: 0;
    }

	.listdivcls{
	  padding: 30px;
	  margin-top: 40px;
	  border-radius: 20px;
	  background: #FFFFFF;
	  padding-bottom: 15px;
	  margin-bottom:40px;
	}
}

.texttitle{
	/* 9月优秀学员 */
	font-family: 思源黑体;
	font-size: 26px;
	font-weight: bold;
	line-height: normal;
	letter-spacing: 0em;
	font-feature-settings: "kern" on;
	/* 333333 */
	color: #333333;
	
}

.gridcls{
	display: grid;
	margin-top: 43px;
    grid-template-columns: repeat(auto-fill, 18.44%);
	justify-content: space-between;
	gap: 30px 0;
}

.itembgcls{
	left: 30px;
	top: 111px;
	height: 480px;
	box-sizing: border-box;
	display:inline-grid;
	
	@media screen and (max-width: 1850px) {
		  height: 460px;
		}
		
		@media screen and (max-width: 1800px) {
		  height: 440px;
		}
		@media screen and (max-width: 1700px) {
		  height: 430px;
		}
		@media screen and (max-width: 1600px) {
		  height: 410px;
		}
		@media screen and (max-width: 1200px) {
		  height: 460px;
		}
	.itemb2{
		overflow: hidden;
		position: relative;
		height: 480px;
		@media screen and (max-width: 1850px) {
		  height: 460px;
		}
		
		@media screen and (max-width: 1800px) {
		  height: 440px;
		}
		@media screen and (max-width: 1700px) {
		  height: 430px;
		}
		@media screen and (max-width: 1600px) {
		  height: 410px;
		}
		
		@media screen and (max-width: 1200px) {
		  height: 460px;
		}
	}
	
	.bgimgcls{
		display: flex;
		justify-content: center;
		align-items: center;
		/* 圆形 31 */
		position: relative;
		width: 100%;
		box-sizing: border-box;
		border: none; 
		background: url(../static/yx_bg1.png) no-repeat;
		background-size: 100% 100%;
	}
	
	.itemimag2{
		width: 11vw;
		height: 11vw;
		margin-top: 1vw;
		margin-bottom: 1vw;
		border-radius: 10vw;
		border: none;
	}
	
	.bgcls3{
		/* 矩形 5 */
		position: absolute;
		width: 100%;
		height: 425px;
		border-radius: 20px;
		bottom: 0;
		opacity: 1;
		z-index: 0;
		background: linear-gradient(180deg, #FFFFFF 7%, #D9F1E5 50%);
		box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);
		
		@media screen and (max-width: 1600px) {
		  height: 405px;
		}
	}
	.text{
		font-weight: bold;
		line-height: 30px;
		text-align: center;
		/* 绿 */
		color: #0AA26B;
	}
	.textdivlcs{
		font-family: 思源黑体;
		font-size: 18px;
		font-feature-settings: "kern" on;
		letter-spacing: 0em;
		
		@media screen and (max-width: 768px) {
		   font-size: 16px;
		}
		
	}
	
	.textcls1{
			font-size: 28px;
			@media screen and (max-width: 768px) {
			   font-size: 24px;
			}
	}
	.textcls2{
	 font-size: 20px;
	 @media screen and (max-width: 768px) {
	    font-size: 18px;
	 }
	}
	
}


.fixed-img{
	width: 120px;
	height: 160px;
	position: fixed;
	right: 44px;
	top: 300px;
	&:hover {
		cursor: pointer;
	}
}

  .no-data {
            width: 338px;
            height: 298px;
        }
.content-box{
	margin-bottom: 20px;
	font-family: Source Han Sans;
	font-size: 20px;
	font-weight: normal;
	line-height: normal;
	text-align: center;
	letter-spacing: 0em;
	
	font-feature-settings: "kern" on;
	/* 333333 */
	color: #333333;
}

</style>